export default __webpack_public_path__ + "static/media/gum2.4b13b50b.png";